import { authService } from '../services/auth';

/**
 * Redirect the user back to a client/service after login.
 *
 * When a `clientId` is present, the redirect is routed through the backend's
 * `post_login_redirect` endpoint, which validates `serviceRedirectUrl` against
 * that client's `allowed_redirect_domains` whitelist and only then returns the
 * final redirect URL (with a one-time code appended). If the URL is not
 * whitelisted for the client, the backend rejects it and this function throws
 * WITHOUT redirecting — callers are expected to surface the error instead of
 * sending the user anywhere. This prevents a non-whitelisted `client_id`/URL
 * pair (passed through the page URL) from being used as an open redirect.
 */
export const handleRedirectLogin = async (serviceRedirectUrl: string, clientId?: string): Promise<void> => {
  if (!clientId) {
    // No client → no whitelist to enforce (internal/first-party redirect).
    window.location.href = serviceRedirectUrl;
    return;
  }

  const { redirectUrl } = await authService.getPostLoginRedirect(serviceRedirectUrl, clientId);
  window.location.href = redirectUrl;
};
